import { memo } from "react";

import type { InputMaybe } from "@/lib/gql/__generated__/graphql";

import { FeatureIslandCategoryQuestionForMain } from "@/components/features/_layouts/island/main-with-category/components/category-main-question";
import type { ForNodeType } from "@/components/features/_model/types";

import { InputNumberField } from "@/components/ui/form/fields/input-field/input-number";

type Props = {
	maxRoomNum: ForNodeType<InputMaybe<number> | undefined> | undefined;
	minRoomNum: ForNodeType<number>;
	onSetMaxRoomNum: (input: number | null | undefined) => void;
	onSetMinRoomNum: (input: number | null | undefined) => void;

	label?: string;
	guide?: string;
};

export const QuestionMinAndMaxNum = memo(
	({ maxRoomNum, minRoomNum, onSetMaxRoomNum, onSetMinRoomNum, label: _label, guide: _guide }: Props) => {
		const onChangeMinNum = (e: number | undefined) => {
			const value = e ?? undefined;

			onSetMinRoomNum(value);
		};

		const onChangeMaxNum = (e: number | undefined) => {
			const value = e ?? undefined;

			onSetMaxRoomNum(value);
		};

		const label = _label || "１度の予約につき宿泊可能な部屋";
		const guide =
			_guide ||
			"１度の予約で選択しなければならない部屋数の制限を設定することができます。<br /><br />例：イベントで予約が集中することが予想される場合<br /><br />最大1部屋までと設定することで一つの団体様に複数の部屋を押さえられてしまうことを防ぐことができます。";

		const isEdited = maxRoomNum?.isEdited ?? minRoomNum?.isEdited ?? false;
		const hasError = Boolean(maxRoomNum?.error || minRoomNum?.error);

		return (
			<FeatureIslandCategoryQuestionForMain
				required={false}
				title={label}
				guide={guide}
				isEdited={isEdited}
				hasError={hasError}
				inputChildren={
					<div className="space-y-6">
						<div className="flex items-center gap-x-2">
							<p>１度の予約で、最低</p>
							<InputNumberField
								handleInput={onChangeMinNum}
								errorMessage={minRoomNum.error}
								value={minRoomNum.value}
								hiddenSpinButton={false}
							/>
							<p>部屋から予約可能</p>
						</div>
						<div className="flex items-center gap-x-2">
							<p>１度の予約で、最高</p>
							<InputNumberField
								handleInput={onChangeMaxNum}
								errorMessage={maxRoomNum?.error}
								value={maxRoomNum?.value ?? undefined}
								hiddenSpinButton={false}
							/>
							<p>部屋まで予約可能</p>
						</div>
					</div>
				}
			/>
		);
	},
);

QuestionMinAndMaxNum.displayName = "QuestionMinAndMaxNum";
